import { render, staticRenderFns } from "./FileGroupList.vue?vue&type=template&id=1359ab7f&scoped=true&"
import script from "./FileGroupList.vue?vue&type=script&lang=ts&"
export * from "./FileGroupList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359ab7f",
  null
  
)

export default component.exports